import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import type { DummyRoomInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "roomID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type ProductDummyRoomFormModel = AutoGeneratorForFormModel<DummyRoomInputZodSchemaType, ExcludeKeys, QueryData>;

export type QueryData = {
	connection: {
		planNameAndIDOptions: FormOptionType[];
	};
};
